// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/info/index.css
// module id = 869
// module chunks = 153